function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable prefer-arrow-callback */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as styles from '../../styles/radio';
import { jsx as ___EmotionJSX } from "@emotion/core";
function BaseRadio(props, ref) {
  var isTile = props.isTile,
    tileAppearance = props.tileAppearance,
    disabled = props.disabled,
    size = props.size;
  // props to pass to the input
  var radioProps = {
    defaultChecked: props.defaultChecked,
    disabled: props.disabled,
    id: props.id,
    name: props.name,
    onBlur: props.onBlur,
    onClick: props.onClick,
    onChange: props.onChange,
    onFocus: props.onFocus,
    value: props.value,
    size: props.size
  };

  // Don't set props.checked unless it's passed as a prop or
  // it becomes a controlled component
  if (props.checked !== undefined) {
    radioProps.checked = props.checked;
  }
  var labelClasses = classnames({
    'domain-radio__label': true,
    [props.className]: !!props.className,
    'is-disabled': disabled,
    isTile,
    'tile-segment': tileAppearance === 'segment'
  });
  var radioClasses = classnames({
    'domain-radio': true,
    'is-disabled': disabled
  });

  // The psuedo label element
  var labelText;
  if (props.labelContent) {
    labelText = ___EmotionJSX("span", {
      className: "domain-radio__label-text",
      css: styles.labelText({
        isTile,
        tileAppearance,
        size
      })
    }, props.labelContent);
  }
  return ___EmotionJSX("label", {
    className: labelClasses,
    css: styles.label({
      isDisabled: disabled,
      isTile,
      tileAppearance,
      size
    })
  }, ___EmotionJSX("input", _extends({
    type: "radio",
    className: "domain-radio__input"
  }, radioProps, {
    "aria-invalid": props.ariaInvalid,
    "aria-describedby": props.ariaDescribedBy,
    "aria-labelledby": props.ariaLabelledBy,
    css: styles.input,
    ref: ref
  })), !isTile && ___EmotionJSX("span", {
    className: "domain-radio__label-radio",
    css: styles.labelRadio
  }, ___EmotionJSX("span", {
    className: radioClasses,
    css: styles.radio(!!disabled)
  })), labelText);
}
BaseRadio.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  labelContent: PropTypes.node,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  isTile: PropTypes.bool,
  tileAppearance: PropTypes.oneOf(['default', 'segment']),
  ariaInvalid: PropTypes.bool,
  ariaDescribedBy: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  size: PropTypes.oneOf(['small', 'mini', 'regular'])
};
var defaultProps = {
  checked: undefined,
  className: undefined,
  defaultChecked: undefined,
  disabled: undefined,
  id: undefined,
  value: undefined,
  labelContent: undefined,
  isTile: false,
  tileAppearance: 'default',
  ariaInvalid: undefined,
  ariaDescribedBy: undefined,
  ariaLabelledBy: undefined,
  onClick: () => {},
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  size: 'regular'
};
BaseRadio.defaultProps = defaultProps;
var Radio = /*#__PURE__*/forwardRef(BaseRadio);
Radio.defaultProps = defaultProps;
export default Radio;